export const RaceTrack = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9 2H3.89474C2.8483 2 2 2.8483 2 3.89474V3.89474C2 4.94117 2.8483 5.78947 3.89474 5.78947H7.89474C9.05744 5.78947 10 6.73203 10 7.89474V7.89474C10 9.05744 9.05744 10 7.89474 10H3"
                stroke="#838A85"
                strokeLinecap="round"
            />
            <circle cx="9.5" cy="2" r="1" fill="#838A85" />
            <circle cx="2.5" cy="10" r="1" fill="#838A85" />
        </svg>
    );
};
